
import React, { useState } from "react";
import PricingCard from "./PricingCard";
import ZeegBookingButton from "@/components/booking/ZeegBookingButton";
import { ArrowRight, ExternalLink, Info } from "lucide-react";
import { Link } from "react-router-dom";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const PersonalPricingSection = () => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const handleTooltipToggle = () => {
    setIsTooltipOpen(prev => !prev);
  };

  return (
    <section className="py-12 md:py-24 bg-white">
      <div className="container px-4 sm:px-6 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-8">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm">
            Angebote für Privatpersonen
          </span>
          <h2 className="mb-4">
            Individuelles Coaching für Ihre finanziellen Ziele
          </h2>
          <p className="text-joerg-600">
            Maßgeschneiderte Begleitung für Ihre persönliche finanzielle Entwicklung.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <PricingCard title="Flex-Zeit" description="Coaching, wie du es brauchst." price="145 €" period="60 Min." features={["Individuelle Begleitung nach deinem Tempo", "Flexibel als 60-Minuten-Einheit nutzbar", "Ideal für punktuelle Unterstützung", "Im kostenfreien Erstgespräch klären wir gemeinsam deine Bedürfnisse"]} primaryCTA={{
          text: "Mehr erfahren",
          link: "/paketinfo"
        }} delay={0} backgroundColor="bg-[#E8F1FB]" // Light blue for clarity & openness
        />
          
          <PricingCard title="Perspektivwechsel" description="Für Themen, die Raum brauchen." price="399 €" period="3 x 60 Min." features={["Entwickle neue Sichtweisen auf deine finanziellen Themen", "Inkl. zusätzlichem 15-minütigen Follow-Up-Gespräch", "Ideal für mittelfristige Veränderungsprozesse", "Du sparst 36 € gegenüber Einzelbuchungen (statt 435 €)"]} primaryCTA={{
          text: "Mehr erfahren",
          link: "/paketinfo"
        }} delay={150} backgroundColor="bg-[#EDF5E9]" // Sage green for freshness & orientation
        />
          
          <PricingCard title="Tiefe Veränderung" description="Für langfristige Entwicklung." price="789 €" period="6 x 60 Min." features={["Nachhaltige Begleitung über sechs Einheiten hinweg", "Inkl. 30-minütigem Follow-Up-Gespräch zur Integration", "Struktur und Tiefe für transformative Prozesse", "Du sparst 81 € gegenüber Einzelbuchungen (statt 870 €)"]} primaryCTA={{
          text: "Mehr erfahren",
          link: "/paketinfo"
        }} delay={300} backgroundColor="bg-[#E9E6F4]" // Lavender for trust & depth
        />
        </div>
        
        <div className="mt-8 text-center">
          <p className="text-sm text-joerg-500">Alle Preise verstehen sich inkl. 19% MwSt. gemäß §19 UStG.</p>
          
          <div className="mt-8 p-4 bg-joerg-50 rounded-lg max-w-xl mx-auto">
            <h3 className="text-lg font-medium mb-2">Unsicher, welches Angebot passt?</h3>
            <p className="mb-4 text-joerg-600">Im kostenfreien Erstgespräch finden wir gemeinsam heraus, welche Option für Ihre Situation am besten geeignet ist.</p>
            <div className="flex justify-center">
              <ZeegBookingButton className="w-full sm:w-auto bg-joerg-700 hover:bg-joerg-800 text-white" text="Unverbindliches Erstgespräch vereinbaren" size="default" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PersonalPricingSection;
